var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktokDesktopSocialEmbed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FE2C55",
  d: "M11 22c6.075 0 11-4.925 11-11S17.075 0 11 0 0 4.925 0 11s4.925 11 11 11"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M11.287 7.302a.516.516 0 0 1 1.016.178l-1.257 7.182a.516.516 0 1 1-1.015-.177zm3.6.741a.64.64 0 0 0-.93 0 .697.697 0 0 0 0 .963l2.042 2.114-2.042 2.113a.7.7 0 0 0 0 .963.64.64 0 0 0 .93 0l2.947-3.05a.04.04 0 0 0 0-.052l-.213-.22-.006-.008zm-6.738 6.153a.68.68 0 0 1-.963 0L4.97 11.98l-.606-.606-.227-.227a.037.037 0 0 1 0-.053l3.05-3.05a.68.68 0 1 1 .962.963l-2.113 2.113 2.114 2.115a.68.68 0 0 1 0 .962"
}))));
export default SvgTiktokDesktopSocialEmbed;